import { i as isAuthenticated } from "../../../chunks/auth.server.js";
import { redirect } from "@sveltejs/kit";
import { a as privateInstance } from "../../../chunks/env.js";
const load = async ({ locals, route }) => {
  if (privateInstance && !isAuthenticated(locals) && route.id !== "/(app)/[shorten]") {
    redirect(302, "/login");
  }
  return {};
};
export {
  load
};
